<script lang="ts" setup>
import { computed } from 'vue'

import { getGridStyles } from './utils'

import type { IGridAreas } from '@/types/serverGrid.type'

const props = defineProps<{
  areas: IGridAreas
  activeAreas?: string[]
}>()

const styles = computed(() => getGridStyles(props.areas, props.activeAreas))
</script>

<template>
  <div
    v-if="styles"
    class="layout-grid"
    :style="styles"
  >
    <slot />
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use '@/styles/variables.scss' as vars;

.layout-grid {
  display: grid;
  grid-template-columns: repeat(var(--layout-grid-mobile-columns), minmax(0, 1fr));
  grid-template-areas: var(--layout-grid-mobile-areas);
  gap: 1rem;
}

@media #{map.get(vars.$display-breakpoints, 'sm-and-up')} {
  .layout-grid {
    grid-template-columns: repeat(var(--layout-grid-tablet-columns), minmax(0, 1fr));
    grid-template-areas: var(--layout-grid-tablet-areas);
  }
}

@media #{map.get(vars.$display-breakpoints, 'md-and-up')} {
  .layout-grid {
    grid-template-columns: repeat(var(--layout-grid-desktop-columns), minmax(0, 1fr));
    grid-template-areas: var(--layout-grid-desktop-areas);
  }
}

@media #{map.get(vars.$display-breakpoints, 'lg-and-up')} {
  .layout-grid {
    grid-template-columns: repeat(var(--layout-grid-wide-columns), minmax(0, 1fr));
    grid-template-areas: var(--layout-grid-wide-areas);
  }
}
</style>
